import { EnergyConfig } from '@_models/vehicleInfo/vehicleConfig/energy-config.model';

export class VehicleConfig {
	id: number;
	electric: EnergyConfig;
	diesel: EnergyConfig;
	gas: EnergyConfig;
	electricComp: EnergyConfig;
}
